enum ComponentType {
  TBolt = 't_bolt',
  CastInChannel = 'cast_in_anchor_channel',
  ConcreteSlab = 'concrete_slab',
  ProductVariant = 'product_variant',
  Group = 'group'
}

export default ComponentType
